export default "__VITE_ASSET__D$QeazqY__"